// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hu","advertCardPhoto__image":"c-a_hv"};